import styled from 'styled-components';
import { space } from 'styled-system';

import { NavLink as VersionedNavLink } from 'components/RouterLink';

import { linkStyles } from './Link';

export const RouterNavLink = styled(VersionedNavLink)`
  ${linkStyles}
  ${space}
`;
